import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@core/interface/api-response.interface';
import { UrlBuilder } from '@core/model/url-builder';
import { PageableResponse } from '@core/interface/pageable.interface';
import { ListCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/list-company-collector-schema-request.dto';
import { GetCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/get-company-collector-schema-request.dto';
import { CompanyCollectorSchemaResponseDto } from '@domain/company-collector-schema/dtos/company-collector-schema-response.dto';
import { CreateCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/create-company-collector-schema-request.dto';
import { UpdateCompanyCollectorSchemaRequestDto } from '@domain/company-collector-schema/dtos/update-company-collector-schema-request.dto';
import { RefId } from '@core/interface/ref-id.interface';

@Injectable({
  providedIn: 'root',
})
export class CompanyCollectorSchemaService extends UrlBuilder {
  constructor(private http: HttpClient) {
    super('company/collector/schema');
  }

  list(request: ListCompanyCollectorSchemaRequestDto) {
    const queryUrl = `${this.getApiUrl()}/list`;
    return this.http.get<
      ApiResponse<PageableResponse<CompanyCollectorSchemaResponseDto>>
    >(queryUrl, {
      params: { ...request },
    });
  }

  get(request: GetCompanyCollectorSchemaRequestDto) {
    const queryUrl = `${this.getApiUrl()}/get`;
    return this.http.get<
      ApiResponse<CompanyCollectorSchemaResponseDto[]>
    >(queryUrl, {
      params: { ...request } as any,
    });
  }

  create(request: CreateCompanyCollectorSchemaRequestDto) {
    const queryUrl = `${this.getApiUrl()}/`;
    return this.http.post<ApiResponse<CompanyCollectorSchemaResponseDto>>(
      queryUrl,
      request,
    );
  }

  update(refId: string, request: UpdateCompanyCollectorSchemaRequestDto) {
    const queryUrl = `${this.getApiUrl()}/${refId}`;
    return this.http.put<ApiResponse<CompanyCollectorSchemaResponseDto>>(
      queryUrl,
      request,
    );
  }

  updateState(refId: string, state: string) {
    const queryUrl = `${this.getApiUrl()}/${refId}/state`;
    return this.http.patch<ApiResponse<CompanyCollectorSchemaResponseDto>>(
      queryUrl,
      { state },
    );
  }

  delete(request: RefId) {
    const queryUrl = `${this.getApiUrl()}/${request.refId}`;
    return this.http.delete<ApiResponse<CompanyCollectorSchemaResponseDto>>(
      queryUrl,
    );
  }

  show(refId: string) {
    const queryUrl = `${this.getApiUrl()}/show/${refId}`;
    return this.http.get<ApiResponse<CompanyCollectorSchemaResponseDto>>(
      queryUrl,
    );
  }
}
